<template>
  <div
    ref="rootEl"
    @click="onClickContent"
  >
    <div v-if="type === 'removed'" class="section-editor viewer content-viewer" v-html="oldHtml" />
    <div v-else-if="type === 'added'" class="section-editor viewer content-viewer" v-html="newHtml" />
    <div v-else class="content-viewer-compare">
      <div class="section-editor viewer content-viewer" v-html="oldHtml" />
      <div class="section-editor viewer content-viewer" v-html="newHtml" />
    </div>
  </div>
</template>

<script>
import { nextTick, ref, watch } from 'vue'
import { contentToHtml } from './viewerEditor'
import { applyDomSearchHighlight, clearDomSearchHighlight } from './searchHighlight'

export default {
  name: 'DiffContentViewerCompare',
  props: {
    oldValue: {
      type: [String, Object, Array, Number, Boolean],
      default: '',
    },
    newValue: {
      type: [String, Object, Array, Number, Boolean],
      default: '',
    },
    type: {
      type: String,
      default: '',
    },
    keyword: {
      type: String,
      default: '',
    },
  },
  setup(props) {
    const rootEl = ref(null)
    const oldHtml = ref('')
    const newHtml = ref('')
    let loadId = 0

    const applyHighlight = async () => {
      await nextTick()
      const root = rootEl.value
      if (!root) return
      const keyword = (props.keyword || '').trim()
      if (!keyword) {
        clearDomSearchHighlight(root)
        return
      }
      applyDomSearchHighlight(root, keyword)
    }

    const load = async () => {
      loadId += 1
      const id = loadId
      const nextOld = props.type === 'added' ? '' : await contentToHtml(props.oldValue)
      if (id !== loadId) return
      const nextNew = props.type === 'removed' ? '' : await contentToHtml(props.newValue)
      if (id !== loadId) return
      oldHtml.value = nextOld
      newHtml.value = nextNew
      applyHighlight()
    }

    watch(
      () => [props.oldValue, props.newValue, props.type],
      load,
      { immediate: true, deep: true },
    )

    watch(
      () => props.keyword,
      applyHighlight,
    )

    const onClickContent = (e) => {
      const link = e.target?.closest?.('a')
      if (link && rootEl.value?.contains(link)) e.preventDefault()
    }

    return {
      rootEl, oldHtml, newHtml, onClickContent,
    }
  },
}
</script>

<style>
.content-viewer-compare {
  display: flex;
  gap: 16px;
  min-width: 0;
  width: 100%;
}

.content-viewer {
  min-width: calc(50% - 8px);
  max-height: 500px;
  overflow: auto;
  border: 1px solid #eeeeee;
  border-radius: 4px;
  padding: 16px;
}
</style>
